module.exports = __webpack_public_path__ + "a1160e1ed85f3be2d0989159af7afa6f.pdf";